// extracted by mini-css-extract-plugin
export var hidden = "_up-0";